import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Select,  Space, Spin, Switch, Table,  Typography } from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined, InfoOutlined, LinkOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import chainselectorreducer from './reducer';

import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { ADD_CHAINSELECTOR_LIST, ADD_CHAINSELECTOR_LIST_ERROR, ADD_CHAINSELECTOR_LIST_SUCCESS, CHAINSELECTOR_LIST, CHAINSELECTOR_LIST_DETAILS_SUCCESS, CHAINSELECTOR_LIST_ERROR, CHAINSELECTOR_LIST_SUCCESS, CHAINSELECTOR_LIST_UPDATE, CHAINSELECTOR_LIST_UPDATE_ERROR, CHAINSELECTOR_LIST_UPDATE_SUCCESS, DELETE_CHAINSELECTOR_LIST, DELETE_CHAINSELECTOR_LIST_ERROR, DELETE_CHAINSELECTOR_LIST_SUCCESS } from './constants';

const { Title } = Typography;

export default function ChainSelector() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const initalState = {wellalgorithmUpdateData : {}, chainselectordata : [],  loading: false, error: false, details : []};
	const [data, dispatch] = useReducer(chainselectorreducer, initalState);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const { pidsData,  getPids, channelData, getChannels } = useAuth();
	const [showDeleteModal, setShowDeleteModal] = useState();
	const [deleteId, setDeleteId] = useState();
	const [pidsId, setPidsId] = useState(null);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const navigate = useNavigate();
	const [channelId, setChannelId] = useState();
	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4031    );
		loadChainSelector();
		getPids(authtoken);
	}, []);

	useEffect(()=>{
		if(pidsId != null){
			getChannels(authtoken, pidsId);
	
		}
	},[pidsId]);

	const handleToggle = (value,record)=>{
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/chainselector/${record.id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authtoken}`
			},
			data: {
				'status' : value,
				'channelinfoId': record?.channelinfoId 
						
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					Modal.success({ title: `${langdata && langdata.StatusUpdatedSuccessfully ? langdata.StatusUpdatedSuccessfully :'Status Updated Successfully'}` });
					loadChainSelector();
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
		
	};

	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			render : (_,record) => (
				<a onClick={() => {navigate(( '/chainselectorconfig'),{ state: { chainselectorId:record.id, channelinfoId : record.channelinfoId } });}}>
					{record.name}
				</a>
			)
            
		},
		{
			title: langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name',
			dataIndex: 'channelinfoname',
			key: 'channelinfoname',
		},
		{
			title: langdata && langdata.PidsName ? langdata.PidsName : 'Pids Name',
			dataIndex: 'pidsinfoname',
			key: 'pidsinfoname',
		},
		{
			title: `${langdata&&langdata.Status?langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',
				
			render: (toggle, record) => (
				<>
					<Switch size='small'  value={toggle} onChange={(value) => handleToggle(value,record)} />
				</>
			),
		},
	];
    
	permission==='superadmin' || permission === 'admin' ? 
		columns.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Edit ? langdata.Edit : 'Edit'} onClick={() => {showModal(record);}} ><EditOutlined/></a>
					<a title={langdata && langdata.Delete ? langdata.Delete : 'Delete'} onClick={() => {openUserModal(record);}} ><DeleteOutlined /></a>
				</Space>
			)
		}) : null;

    
	const showModal = (value) => {
		setIsEditModalOpen(true);
		setPidsId(value?.pidsinfoId);
		dispatch({ type : CHAINSELECTOR_LIST_DETAILS_SUCCESS , payload : value});
	};

	const handleOk = () => {
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		createFormik.resetForm();
		editFilterConfig.resetForm();
		setPidsId(null);
		setChannelId(null);

        
	};
	const handleCancel = () => {
    
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		createFormik.resetForm();
		editFilterConfig.resetForm();
		setPidsId(null);
		setChannelId(null);

	};	

	

	const loadChainSelector = ()=>{    
		
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/chainselector?pipelineId=${pipelineId}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : CHAINSELECTOR_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
					dispatch({ type : CHAINSELECTOR_LIST_SUCCESS, payload: response.data });
				} else {
					dispatch({ type : CHAINSELECTOR_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : CHAINSELECTOR_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			pidsinfoId:null,
			channelinfoId:null
            
		},
		onSubmit: (values) => {
			if( name == null){
				Modal.warning({title : langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'});
				return false;
			}
			if( values.pidsinfoId == null){
				Modal.warning({title : langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please select the pids'});
				return false;
			}
			if( values.channelinfoId == null){
				Modal.warning({title : langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel'});
				return false;
			}
			const payload = {
				name: values.name,
				pidsinfoId: values.pidsinfoId,
				channelinfoId: values.channelinfoId,
				pipelineId : parseInt(pipelineId)
			};
            
        
            
			dispatch({ type : ADD_CHAINSELECTOR_LIST });
			// let data = JSON.stringify({
			// 	'name' : name,
			// 	'pipelineId':parseInt(pipelineId)
                
			// });

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/chainselector`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : {
					name : payload.name,
					pidsinfoId: payload.pidsinfoId,
					channelinfoId: payload.channelinfoId,
					pipelineId : payload.pipelineId
				} 
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){
						loadChainSelector();
								
						Modal.success({ title: langdata && langdata.ChainselectorAddedsuccessfully ? langdata.ChainselectorAddedsuccessfully : 'Chainselector Added successfully.' });					
						dispatch({ type : ADD_CHAINSELECTOR_LIST_SUCCESS });
					} else {
						dispatch({ type : ADD_CHAINSELECTOR_LIST_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletosavechainselector ? langdata.Unabletosavechainselector : 'Unable to save chain selector' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : ADD_CHAINSELECTOR_LIST_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavechainselector ? langdata.Unabletosavechainselector : 'Unable to save chain selector' });					
					}
				});
			createFormik.resetForm();
			setIsAddModalOpen(false);

		}
	});	
        
	const openUserModal = (value) => {
		setShowDeleteModal(true);
		setDeleteId(value.id);
	};

	const handleDelete = () => {
		dispatch({ type : DELETE_CHAINSELECTOR_LIST });
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/chainselector/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				},
			data : data
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadChainSelector();
										
					Modal.success({ title: langdata && langdata.chainselectorsuccessfullydeleted ? langdata.chainselectorsuccessfullydeleted : 'Chain selector successfully deleted.' });					
					dispatch({ type : DELETE_CHAINSELECTOR_LIST_SUCCESS });
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodelete ? langdata.Unabletodelete : 'Unable to delete.' });					
					dispatch ({ type : DELETE_CHAINSELECTOR_LIST_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch ({ type : DELETE_CHAINSELECTOR_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodelete ? langdata.Unabletodelete : 'Unable to delete.' });
				}
			});
		setShowDeleteModal(false);
		
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.Chainselectorinfocontent ? langdata.Chainselectorinfocontent : 'Chain Selector is the module that selects and verifies predictions from multiple chains to make the final decision.'} </p>
		</Card>
	);


	const editFilterConfig = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data?.details?.name,
			channelinfoId: data?.details?.channelinfoId,
			pidsinfoId: data?.details?.pidsinfoId,

		},
		onSubmit: (values) => {

			const payload = {
				name: values.name,
				channelinfoId: values.channelinfoId,
				pidsinfoId: values.pidsinfoId
			};
            
        
			dispatch({type:CHAINSELECTOR_LIST_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/chainselector/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data:{
					name : payload.name,
					channelinfoId : payload.channelinfoId,
					pidsinfoId : payload.pidsinfoId,
					pipelineId : parseInt(pipelineId) 
				}
			};
        
			axios
				.request(config)	
				.then((response) => {
                            
        
					if (response.status === 200 || response.status === 201) {

						dispatch( { type: CHAINSELECTOR_LIST_UPDATE_SUCCESS, payload: response.data.data });
						
						Modal.success({ title: `${langdata && langdata.EditChainselectorSuccessfull ? langdata.EditChainselectorSuccessfull :'Edit Chain selector Successfull'}` });
						setIsEditModalOpen(false);
						loadChainSelector();
						// loadFilterConfiguration();
						// form.resetFields();
						// addModelClassification.resetForm();
						// setOpenAddDrawer(false);
        
                            
					}
				})
				.catch((error) => {
					console.log(error);
                            
					dispatch({ type: CHAINSELECTOR_LIST_UPDATE_ERROR
					});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
        
		}
	});

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	let pidsModalFilter = [];
	
	pidsData && pidsData.map((pid)=>{
		pidsModalFilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});

	const handleSelect = (e, option)=> {
		setPidsId(e);
		if(option == 'add'){
			createFormik.setFieldValue('pidsinfoId', e);
			createFormik.setFieldValue('channelinfoId', null);
			setChannelId(null);
		}
		if(option == 'edit'){
			editFilterConfig.setFieldValue('pidsinfoId', e);
			editFilterConfig.setFieldValue('channelinfoId', null);
			setChannelId(null);

		}
	};
	const handleSelectChannel = (e, options)=>{
		// setchannels(e);
		setChannelId(e);
		if(options == 'add'){
			createFormik.setFieldValue('channelinfoId', e);
		}
		if(options == 'edit'){
			editFilterConfig.setFieldValue('channelinfoId', e);
		}

	};

	let channels = [];
	channelData && channelData.map((item) => {
		channels.push({
			value : item.id,
			label : item.name,
		});
	});
	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<LinkOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.ChainSelector ? langdata.ChainSelector : 'Chain Selector'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
                            
							<Popover title={langdata && langdata.ChainSelector ? langdata.ChainSelector : 'Chain Selector'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data && data.chainselectordata && data.chainselectordata.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { columns } 
							dataSource = { data.chainselectordata } 
							onChange={loadChainSelector}
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>
			<Modal
				title={langdata && langdata.EditChainSelector ? langdata.EditChainSelector : 'Edit Chain Selector'}
				centered
				open={isEditModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={editFilterConfig.handleSubmit}>{langdata && langdata.Save ? langdata.Save : 'Save'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: false, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									onChange={editFilterConfig.handleChange} 
									value={editFilterConfig.values.name}
								/>
							</Form.Item>
						</Col>
                        
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS : 'PIDS'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please fill the pids' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPids ? langdata.SelectPids : 'Select Pids'}
									optionFilterProp="children"
									value={editFilterConfig.values.pidsinfoId}
									options={pidsModalFilter}
									// onSelect={(e)=>setPidsId(e)}
									onSelect={(e)=>handleSelect(e,'edit')}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>

						
						<Col span={24}>
							<Form.Item label={langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.SelectChannel
											? langdata.SelectChannel
											: 'Select Channel'
									}
									optionFilterProp="children"
									// value={channelId}
									value={editFilterConfig?.values?.channelinfoId}
									options={channels}
									disabled={pidsId==null}
									onSelect={(e) => handleSelectChannel(e,'edit')}
																																
																																		
								/>  
							</Form.Item>
						</Col>
					</Row>
                    
				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.AddChainSelector ? langdata.AddChainSelector : 'Add Chain Selector'}
				centered
				open={isAddModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				destroyOnClose= {true}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: false, message: langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name' }]} required>
								<Input 
									name="name"
									placeholder={langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name'} 
									onChange={createFormik.handleChange} 
									// value={editFilterConfig.values.name}
								/>
							</Form.Item>
						</Col>
                        
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS : 'PIDS'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthepids ? langdata.Pleaseselectthepids : 'Please fill the pids' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPids ? langdata.SelectPids : 'Select Pids'}
									optionFilterProp="children"
									// value={editFilterConfig.values.pidsinfoId}
									options={pidsModalFilter}
									// onSelect={(e)=>setPidsId(e)}
									onSelect={(e)=>handleSelect(e,'add')}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>

						
						<Col span={24}>
							<Form.Item label={langdata && langdata.ChannelName ? langdata.ChannelName : 'Channel Name'} rules={[{ required: true, message: langdata && langdata.Pleaseselectthechannel ? langdata.Pleaseselectthechannel : 'Please select the channel' }]} required>
								<Select Item
									showSearch
									filterOption={filterOption}
									placeholder={
										langdata && langdata.SelectChannel
											? langdata.SelectChannel
											: 'Select Channel'
									}
									optionFilterProp="children"
									value={channelId}
									// value={editFilterConfig.values.channelinfoId}
									options={channels}
									disabled={pidsId==null}
									onSelect={(e) => handleSelectChannel(e,'add')}
																																
																																		
								/>  
							</Form.Item>
						</Col>
					</Row>

				
				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis :'Are you sure you want to delete this?'}</Col>
				</Row>
			</Modal>

			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}